module.exports = "/_next/static/images/idris-552695f8d318a6c45cd113374e2be01a.jpg";